import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'unixTimestamp' })
export class UnixTimestampPipe implements PipeTransform {
  transform(value: number, format = 'YYYY-MM-DD'): string {
    return moment(value).format(format);
  }
}